import React from 'react';
import { connect } from 'react-redux';

import { Box, IconButton } from '@mui/material';
import clsx from 'clsx';
import CustomDrawer from 'components/CustomDrawer';
import Tooltip from 'components/Tooltip';
import useReplayTour from 'components/V2/SidebarTour/hooks/useReplayTour';
import PropTypes from 'prop-types';

import { setSidebarCollapse } from 'redux/slices/general';

import styles from '../sidebar.module.css';

import { ReactComponent as CollapseIcon } from 'asset/IconsPack/at_chevron-left-double.svg';
import { ReactComponent as AuthenticateMark } from 'asset/img/Authenticate_ R_Logo.svg';

import AccountMenu from './AccountMenu';
import BrandHeader from './BrandHeader';
import HelpMenu from './HelpMenu';
import NavigationList from './NavigationList';

function DesktopSidebar({ sidebarCollapse, setSidebarCollapse, handleHelpClick }) {
    const replayTour = useReplayTour();

    return (
        <CustomDrawer
            anchor="left"
            variant="permanent"
            className={clsx(styles.desktopDrawer, sidebarCollapse && styles.miniDesktopDrawer)}
        >
            <Box
                className={clsx(
                    styles.desktopHeader,
                    sidebarCollapse && styles.desktopHeaderCollapsed
                )}
            >
                {/* Collapsed, the expand button lives in the page bar. */}
                {sidebarCollapse ? (
                    <AuthenticateMark
                        className={styles.railMark}
                        role="img"
                        aria-label="Authenticate"
                    />
                ) : (
                    <>
                        <BrandHeader className={styles.desktopBrand} />
                        <Tooltip
                            title="Collapse sidebar"
                            placement="right"
                            classes={{ tooltip: styles.collapseTooltip }}
                        >
                            <IconButton
                                className={styles.collapseButton}
                                data-tour="sidebar-toggle"
                                onClick={() => setSidebarCollapse(true)}
                                aria-label="Collapse sidebar"
                                disableRipple
                            >
                                <CollapseIcon className={styles.collapse_icon} />
                            </IconButton>
                        </Tooltip>
                    </>
                )}
            </Box>
            <NavigationList collapseMenu={sidebarCollapse} className={styles.desktopNavList} />
            <Box className={styles.sidebarFooter}>
                <HelpMenu
                    collapsed={sidebarCollapse}
                    handleHelpClick={handleHelpClick}
                    onReplayTour={replayTour}
                />
                <AccountMenu collapsed={sidebarCollapse} />
            </Box>
        </CustomDrawer>
    );
}

DesktopSidebar.propTypes = {
    sidebarCollapse: PropTypes.bool,
    setSidebarCollapse: PropTypes.func,
    handleHelpClick: PropTypes.func,
};

function mapStateToProps(state) {
    return {
        sidebarCollapse: state.general?.sidebarCollapse,
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        setSidebarCollapse: (show) => dispatch(setSidebarCollapse(show)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DesktopSidebar);
